import { FilterAlt } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";
import React from "react";

const FilterButton = ({
  handleClick = () => {},
  count = 0,
  showCout = true,
}) => {
  return (
    <Button
      variant="contained"
      onClick={handleClick}
      color="secondary"
      size="large"
    >
      <Stack direction={"row"} alignItems={"center"} gap={{ xs: 1, md: 2 }}>
        <Typography sx={{ fontSize: { xs: "1rem", md: "1.2rem" } }}>
          Filter
        </Typography>
        <FilterAlt />
        {showCout && (
          <Typography
            sx={{
              padding: "0 5px",
              background: "#fff",
              color: "black",
              borderRadius: "50%",
            }}
          >
            {count}
          </Typography>
        )}
      </Stack>
    </Button>
  );
};

export default FilterButton;
